import React, { FunctionComponent, useState } from 'react';

import axios from 'axios';

import { emailRegistrationUrl } from '../../../../config';

import EmailInputForm, { Input } from './EmailInputForm';
import EmailInputModal from './EmailInputModal';
import { useIntl } from 'react-intl';

const EmailInput: FunctionComponent = () => {
  const [submitting, setSubmitting] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const { locale } = useIntl();

  const submit = async (input: Input) => {
    try {
      setSubmitting(true);

      const result = await axios.post(emailRegistrationUrl, {
        ...input,
        locale,
      });

      if (result.data.ok) {
        setOpen(true);
        if (result.data.ios && result.data.android) {
          setMessage('both');
        } else if (result.data.ios && !result.data.android) {
          setMessage('ios');
        } else if (!result.data.ios && result.data.android) {
          setMessage('android');
        }
      }
    } catch (e) {
      console.log({ e });
      setOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <EmailInputForm onSubmit={submit} submitting={submitting} />
      <EmailInputModal open={open} onClose={onClose} message={message} />
    </>
  );
};

export default EmailInput;
